import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Container, Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap';
import Form from './Form';
import config from 'config';
import { ApiService } from '../../../services';
import { getPreviewSrc, encodeFileName } from '../../../helpers/filesPreview';

import './Edit.scss';

export interface SuspensionRequest {
  id: string | undefined;
  nombre: string;
  apellido: string;
  delegacion: string;

  motivo_solicitud: string;
  fecha_desde: string;
  fecha_hasta: string;

  nro_resolucion: string | null;
  ano_resolucion: number | null;

  motivo_rechazo: string;

  state_id: string;

  attachs: RequestAttachment[];
}

export interface RequestAttachment {
  id: number;
  request_id: number;
  request_type: string;
  attachment_type: string;
  url: string;
  created_at: string;
}

export interface GalleryItem {
  src: string;
  downloadUrl: string;
  alt: string;
}

function View() {
  const { id } = useParams();

  const [data, setData] = useState<SuspensionRequest>({
    id: id,
    nombre: '',
    apellido: '',

    delegacion: '',

    motivo_solicitud: '',
    fecha_desde: '',
    fecha_hasta: '',

    nro_resolucion: null,
    ano_resolucion: null,

    motivo_rechazo: '',

    state_id: '',

    attachs: [],
  });

  const [gallery, setGallery] = useState<GalleryItem[]>([]);
  const galleryContainer = useRef(null);

  const ATTACHMENTS_CONFIG = [
    { key: 'documentacion_motivo', alt: 'Documentación respaldatoria' },
  ] as const;

  useEffect(() => {
    ApiService.getOne('matriculates/suspension', id)
      .then(({ payload }) => {
        setData(payload);

        const attachs = ATTACHMENTS_CONFIG.flatMap(({ key, alt }) => {
          if (!payload.attachs?.length) return [];

          const filtered = payload.attachs
            .filter((a: RequestAttachment) => a.attachment_type.startsWith(key))
            .sort((a: RequestAttachment, b: RequestAttachment) => {
              const indexA = parseInt(a.attachment_type.split('_').pop() || '0');
              const indexB = parseInt(b.attachment_type.split('_').pop() || '0');
              return indexA - indexB;
            });

          let i = 0;
          return filtered.map((a: RequestAttachment) => {
            const encodedPath = encodeFileName(a.url);
            i++;

            return {
              src: getPreviewSrc(encodedPath),
              downloadUrl: `${config.baseUrl}/${encodedPath}`,
              // @ts-ignore
              alt: `${alt} ${i}`,
            };
          });
        });

        setGallery(attachs);
      })
      .finally(() =>{
      });
  }, [id]);

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body"></div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Card className="bg-secondary shadow">
          <CardHeader>
            <Row>
              <Col md="8">
                <h3 className="mb-0">Solicitud de Suspensión #{ id }</h3>
              </Col>
              <Col md="4" className="text-right">
                <Link to='/admin/matriculates/requests'>
                  <Button color="primary" size="md">Volver</Button>
                </Link>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Form
              data={ data }
              gallery={ gallery }
              galleryContainer={ galleryContainer }
              isLoading={ false }
              onAccept={ false }
              onReject={ false }
            />
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default View;
